import React from 'react';
import './RecentWinners.css';

function RecentWinners({ winners = [] }) {
  const defaultWinners = [
    { id: 1, username: 'Winner123', prize: 'Discord Nitro 1 Year', giveaway: 'Monthly Nitro Giveaway', date: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000), avatar: '👑' },
    { id: 2, username: 'LuckyUser', prize: '$50 PayPal', giveaway: 'Cash Giveaway', date: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000), avatar: '⭐' },
    { id: 3, username: 'GiveawayKing', prize: 'Discord Nitro 3 Months', giveaway: 'Nitro Drop', date: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000), avatar: '🎯' },
    { id: 4, username: 'NitroHunter', prize: '$25 Steam Gift Card', giveaway: 'Gaming Giveaway', date: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000), avatar: '🎁' },
    { id: 5, username: 'PrizeSeeker', prize: 'Discord Nitro 1 Month', giveaway: 'Weekly Nitro', date: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000), avatar: '💰' },
  ];

  const displayWinners = winners.length > 0 ? winners : defaultWinners;

  return (
    <div className="recent-winners">
      <div className="recent-winners-header">
        <h2>🏆 Recent Winners</h2>
        <p>Latest giveaway winners</p>
      </div>
      <div className="winners-list">
        {displayWinners.map((winner, index) => (
          <div key={winner.id} className="winner-card">
            <div className="winner-rank">
              {index === 0 && '🥇'}
              {index === 1 && '🥈'}
              {index === 2 && '🥉'}
              {index > 2 && `#${index + 1}`}
            </div>
            <div className="winner-avatar">{winner.avatar}</div>
            <div className="winner-info">
              <h4>{winner.username}</h4>
              <p className="winner-prize">{winner.prize}</p>
              <p className="winner-giveaway">{winner.giveaway}</p>
            </div>
            <div className="winner-date">
              {new Date(winner.date).toLocaleDateString()}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default RecentWinners;

